import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=ae59ccf0"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=ae59ccf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports